import isFunction from 'lodash-es/isFunction'

export const ORDER_DND_TYPE = 'order'

export interface DragItem {
  id: number | string
  index: number
}

export interface DropResult {
  id: number
  index?: number
}

interface EndDragProps<E> {
  id: number | string
  index: number
  onDragEnd?: (resultId: number, entity: E, id: number, index: number, resultIndex: number) => void
}

export function beginDragRow(props: { id: number | string; index: number }): DragItem {
  return { id: props.id, index: props.index }
}

export function endDragRow<E>(props: EndDragProps<E>, entity: E, dropResult: DropResult | null | undefined): void {
  if (dropResult && dropResult.id && isFunction(props.onDragEnd)) {
    props.onDragEnd(dropResult.id, entity, props.id as number, props.index, dropResult.index as number)
  }
}

export function dropOnRow(props: { id: number; index: number }, alreadyDropped: boolean): DropResult | undefined {
  if (alreadyDropped) {
    return undefined
  }
  return { id: props.id, index: props.index }
}

export function dropOnCourier(courierId: number, alreadyDropped: boolean): DropResult | undefined {
  if (alreadyDropped) {
    return undefined
  }
  return { id: courierId }
}

export function dropFiles(onSelectFiles: (files: FileList) => void, files: FileList | null | undefined): void {
  if (files && files.length > 0) {
    onSelectFiles(files)
  }
}
